import { graphql, useStaticQuery } from 'gatsby';
import { createRoutingURI } from '~/scripts/utils/domain';

const useDigitIDQuery = (locale: string) => {
  const data = useStaticQuery(graphql`
    {
      register: allContentfulDefaultHub(
        filter: { contentful_id: { eq: "7paeycUU7PEhMWtIIoDEJa" } }
      ) {
        nodes {
          node_locale
          slug
        }
      }
      privacyPolicy: allContentfulDefaultHub(
        filter: { contentful_id: { eq: "6DP9JH80Ddg5NnEb2wwstu" } }
      ) {
        nodes {
          node_locale
          slug
        }
      }
      termsAndConditions: allContentfulCampaignConfiguration(
        filter: { campaignKey: { eq: "ladestationinfrastruktur" } }
      ) {
        nodes {
          node_locale
          termsAndConditions {
            file {
              url
            }
          }
        }
      }
    }
  `);

  const registerObj = data.register.nodes.find(
    ({ node_locale }: { node_locale: string }) => node_locale === locale,
  );
  const privacyPolicyObj = data.privacyPolicy.nodes.find(
    ({ node_locale }: { node_locale: string }) => node_locale === locale,
  );
  const termsAndConditionsObj = data.termsAndConditions.nodes.find(
    ({ node_locale }: { node_locale: string }) => node_locale === locale,
  );

  return {
    registerUrl: createRoutingURI({
      slug: registerObj.slug,
      locale: registerObj.node_locale,
      root: '',
    }),
    privacyPolicyUrl: createRoutingURI({
      slug: privacyPolicyObj.slug,
      locale: privacyPolicyObj.node_locale,
      root: '',
    }),
    termsAndConditionsUrl:
      termsAndConditionsObj.termsAndConditions?.file.url ?? '/',
  };
};

export default useDigitIDQuery;
